import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { SEO_META_TAGS, getPageMeta } from "../seo/meta";

function setHeadTag(selector, create, attr, value) {
  let el = document.head.querySelector(selector);

  if (!value) {
    el?.remove();
    return;
  }

  if (!el) {
    el = create();
    document.head.appendChild(el);
  }

  el.setAttribute(attr, value);
}

// Обновляет SEO-теги при переходах внутри SPA
function PageMeta() {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = getPageMeta(pathname);
    document.title = meta.title;

    for (const [attr, name, field] of SEO_META_TAGS) {
      setHeadTag(
        `meta[${attr}="${name}"]`,
        () => {
          const el = document.createElement("meta");
          el.setAttribute(attr, name);
          return el;
        },
        "content",
        meta[field],
      );
    }

    setHeadTag(
      'link[rel="canonical"]',
      () => {
        const el = document.createElement("link");
        el.rel = "canonical";
        return el;
      },
      "href",
      meta.url,
    );
  }, [pathname]);

  return null;
}

export default PageMeta;
